(function () {
    'use strict';

    var btn = document.getElementById('archive-load-more');
    if (!btn) return;

    var grid = document.getElementById('archive-posts-grid');
    if (!grid) return;

    var page = parseInt(btn.dataset.page, 10) || 1;
    var max  = parseInt(btn.dataset.max, 10) || 1;
    var loading = false;

    btn.addEventListener('click', function () {
        if (loading || page >= max) return;
        loading = true;

        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Loading…';

        var data = new URLSearchParams();
        data.append('action', 'archive_load_more');
        data.append('nonce', ArchiveLoadMore.nonce);
        data.append('page', page + 1);
        data.append('term', btn.dataset.term || '');
        data.append('taxonomy', btn.dataset.taxonomy || '');
        data.append('query_string', ArchiveLoadMore.queryString || '');

        fetch(ArchiveLoadMore.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: data.toString()
        })
            .then(function (r) { return r.json(); })
            .then(function (res) {
                if (!res.success) {
                    btn.disabled = false;
                    btn.innerHTML = originalHTML;
                    return;
                }
                grid.insertAdjacentHTML('beforeend', res.data.html);
                page = res.data.page;
                max  = res.data.max;
                btn.dataset.page = page;
                btn.disabled = false;

                if (page >= max) {
                    btn.parentNode.style.display = 'none';
                } else {
                    btn.innerHTML = originalHTML;
                }
            })
            .catch(function () {
                btn.disabled = false;
                btn.innerHTML = originalHTML;
            })
            .finally(function () { loading = false; });
    });
})();